<script>
	import { Route, Router } from "svelte-routing";
	import ServiceManage from "./Manage/ServiceManage.svelte";
	import RulesManage from "./Manage/RulesManage.svelte";
	import CreateRule from "./CreateRule.svelte";
	import EditRule from "./EditRule.svelte";
</script>

<Router url="/">
	<Route path="/" component={ServiceManage} />
	<Route path="/manage-rules" component={RulesManage} />
	<Route path="/manage-rules/add-rule" component={CreateRule} />
	<Route path="/manage-rules/edit-rule/:ruleId" let:params>
		<EditRule ruleId={params.ruleId} />
	</Route>
</Router>
